import { Component, Output, EventEmitter, Input } from "@angular/core";

@Component({
    selector: "cell-edit-overlay",
    templateUrl: "./cellEditOverlay.tmpl.html",
    standalone: false
})
export class CellEditOverlay
{

    @Input()
    inlineEdit: boolean;

    @Output()
    doLeaveCellEdit = new EventEmitter<boolean>();

    leaveCellEdit(cancel: boolean): void
    {
        this.doLeaveCellEdit.emit(cancel);
    }
}
